import { IconDeviceFloppy } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { Button, Grid, Group, TagsInput, TextInput } from '@mantine/core';
import { useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import useFetch from '../../helpers/useFetch';

const CompaniesForm = ({ company }) => {
  const navigate = useNavigate();
  const fetch = useFetch();
  const [formData, setFormData] = useState({
    companyId: '',
    name: '',
    email: '',
    phoneNumber: '',
    tags: [],
  });
  const [error, setError] = useState();
  const { accountId, domainId } = useParams();

  useEffect(() => {
    if (company) {
      setFormData(company);
    }
  }, [company]);

  const handleChange = (event) => {
    const element = event.target;

    setFormData((prevFormData) => ({ ...prevFormData, [element.name]: element.value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/companies`, {
      method: 'PUT',
      body: JSON.stringify(formData),
    })
      .then(() => {
        if (company?.companyId) {
          // existed before
          navigate(
            `/accounts/${accountId}/domains/${domainId}/companies/${encodeURIComponent(company.companyId)}/events`
          );
        } else {
          navigate(`/accounts/${accountId}/domains/${domainId}/companies`);
        }
      })
      .catch(setError);
  };

  return (
    <div style={{ width: '100%' }}>
      {error && (
        <div style={{ marginBottom: 10 }}>
          <ErrorMessage message={error.message} />
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Company Id*</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 10 }}>
            <TextInput
              disabled={company?.companyId}
              name="companyId"
              value={formData.companyId}
              placeholder="Company ID"
              onChange={handleChange}
              required
            />
          </Grid.Col>
        </Grid>

        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Name</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 10 }}>
            <TextInput name="name" value={formData.name} placeholder="Name" onChange={handleChange} />
          </Grid.Col>
        </Grid>

        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Email</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 10 }}>
            <TextInput
              name="email"
              type="email"
              value={formData.email}
              placeholder="Email"
              onChange={handleChange}
              required
            />
          </Grid.Col>
        </Grid>

        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Phone number</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 10 }}>
            <TextInput
              name="phoneNumber"
              value={formData.phoneNumber}
              placeholder="Phone number"
              onChange={handleChange}
            />
          </Grid.Col>
        </Grid>

        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Tags</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 10 }}>
            <TagsInput
              data={[]}
              onChange={(tags) => handleChange({ target: { name: 'tags', value: tags } })}
              value={formData.tags || []}
              placeholder="Add tags"
            />
          </Grid.Col>
        </Grid>

        <Group justify="flex-end" mt="md">
          <Button variant="default" onClick={() => navigate(-1)}>
            Back
          </Button>
          <Button type="submit" disabled={!formData.companyId} leftSection={<IconDeviceFloppy size={16} />}>
            Save
          </Button>
        </Group>
      </form>
    </div>
  );
};

export default CompaniesForm;
